export interface Kunde {
  id: string
  name: string
  firma?: string
  adresse?: string
  plz?: string
  ort?: string
  kanton?: string
  telefon?: string
  email?: string
  bexio_id?: string
  favorit?: number
  branche?: string
  notizen?: string
  erstellt_am: string
  aktualisiert_am: string
  geraete_anzahl?: number
  besuche_anzahl?: number
}

export interface KundeDetail extends Kunde {
  geraete: KundenGeraet[]
  besuche: Besuch[]
  defekte: Defekt[]
}

export interface KundenGeraet {
  id: string
  kunde_id: string
  kunde_name?: string
  modell: string
  seriennummer?: string
  kaufdatum?: string
  garantie_bis?: string
  abo_aktiv: number
  status: 'aktiv' | 'defekt' | 'ersetzt' | 'entfernt'
  standort?: string
  notizen?: string
  fotos?: string
  erstellt_am: string
  aktualisiert_am: string
  defekte?: Defekt[]
}

export interface Besuch {
  id: string
  kunde_id: string
  kunde_name?: string
  kunde_firma?: string
  kunde_ort?: string
  kunde_adresse?: string
  kunde_plz?: string
  kunde_telefon?: string
  techniker: string
  datum: string
  uhrzeit_start?: string
  uhrzeit_ende?: string
  typ: 'service' | 'verkauf' | 'installation' | 'garantie' | 'demo' | 'notfall'
  status: 'geplant' | 'unterwegs' | 'abgeschlossen' | 'abgesagt'
  besprochene_punkte?: string
  zusammenfassung?: string
  was_gemacht?: string
  naechste_schritte?: string
  dauer_minuten?: number
  unterschrift?: string
  erstellt_am: string
  aktualisiert_am: string
  defekte?: Defekt[]
}

export interface Defekt {
  id: string
  geraet_id?: string
  besuch_id?: string
  kunde_id: string
  kunde_name?: string
  geraet_modell?: string
  seriennummer?: string
  beschreibung: string
  zustand: 'leicht' | 'mittel' | 'schwer' | 'total-ausfall'
  ursache?: string
  massnahmen?: string
  status: 'offen' | 'in-bearbeitung' | 'behoben'
  fotos: string
  erstellt_am: string
  aktualisiert_am: string
}

export interface Ersatzteil {
  id: string
  bexio_id?: number
  artikelnummer?: string
  bezeichnung: string
  fuer_modell: string
  lagerbestand: number
  mindestbestand: number
  preis?: number
  einheit: string
  lieferant?: string
  erstellt_am: string
}

export interface OffertPosition {
  id: string
  offerte_id: string
  beschreibung: string
  menge: number
  einheit: string
  einzelpreis: number
  rabatt: number
  sort_order: number
}

export interface Offerte {
  id: string
  kunde_id: string
  kunde_name?: string
  nummer: string
  ersteller: string
  status: 'entwurf' | 'gesendet' | 'angenommen' | 'abgelehnt' | 'abgelaufen'
  gueltig_bis?: string
  notizen?: string
  bexio_id?: string
  erstellt_am: string
  aktualisiert_am: string
  positionen?: OffertPosition[]
}

export interface FAQ {
  id: string
  frage: string
  antwort: string
  fuer_modell: string
  kategorie: string
  reihenfolge: number
}

export interface Dashboard {
  kunden: number
  geraete_aktiv: number
  geraete_defekt: number
  besuche_heute: number
  defekte_offen: number
  naechste_besuche: Besuch[]
}

export interface Benutzer {
  id: string
  name: string
  email: string
  rolle: 'admin' | 'alles' | 'techniker' | 'verkauf'
  aktiv: number
  erstellt_am: string
}

export type BesuchTyp = Besuch['typ']
export type BesuchStatus = Besuch['status']
export type DefektZustand = Defekt['zustand']
export type DefektStatus = Defekt['status']
export type GeraetStatus = KundenGeraet['status']
export type OffertStatus = Offerte['status']

export const GERAETE_MODELLE = [
  'DS2 Home',
  'DS2 Pro',
  'DS2 Pro Cart',
  'DS4',
  'DS4+',
  'DS4+ Mobility',
] as const

export interface BetriebsstundenEintrag {
  id: string
  geraet_id: string
  stunden: number
  erfasst_am: string
  notiz?: string
  erstellt_am: string
}

export interface ServiceErsatzteilPosition {
  id: string
  bezeichnung: string
  menge: number
  einzel_preis: number
}

export interface ServiceAuftrag {
  id: string
  nummer?: string
  kunde_id: string
  geraet_id: string
  kunde_name?: string
  kunde_firma?: string
  geraet_modell?: string
  seriennummer?: string
  beschreibung: string
  garantie: number
  status: 'offen' | 'in_bearbeitung' | 'abgeschlossen' | 'versendet'
  reparatur_log?: string
  was_ersetzt?: string
  ersatzteile: string
  zeit_minuten: number
  kosten: number
  verrechnet: number
  bexio_rechnung_id?: string
  ruecksendung_datum?: string
  ruecksendung_tracking?: string
  ruecksendung_notizen?: string
  fotos?: string
  erstellt_am: string
  aktualisiert_am: string
}

export const BRANCHEN = [
  'Gastronomie',
  'Hotellerie',
  'Lebensmittelproduktion',
  'Fitness',
  'Schulen',
  'Industrie',
  'Fahrzeugpflege',
  'Gesundheitswesen',
  'Büro',
  'Sonstiges',
] as const
